<template>
  <div id="app">
    <!-- 由匹配到的组件，将渲染到这个标签里 -->


    <router-view/>
<!-- 这里是简写，原代码应该为<router-view></router-view> -->
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  max-width:750px;
  margin-left:auto;
  margin-right:auto;

}
body{
  margin:0;
  overflow-y:scroll;
  background-color: #FFFFFF;
}
input{
  /* border:none!important; */
  background-color: transparent;
}
.el-button--success{
  background-color: var(--theme-color)!important;
  border-color: var(--theme-color)!important;
}
.el-dialog__body{
  text-align: center!important;
}
:root{
  --theme-color:#b22830;

}

</style>



// WEBPACK FOOTER //
// src/App.vue